import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { getOrganization } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./Upsell.module.scss";

const DEMO_THRESHOLD = 5;

interface Props {
  demographicDataEnabled: boolean;
  orgSize: number;
}

const Upsell: React.FC<Props> = ({ demographicDataEnabled, orgSize }) => {
  const intl = useIntl();

  const singleButton = orgSize < DEMO_THRESHOLD;

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {demographicDataEnabled
          ? intl.formatMessage({
              id: "map.layer.boundaries.legend.territories.upsell.title",
              defaultMessage: "Upgrade to Build Territories",
              description: "Title of the upsell legend for territories",
            })
          : intl.formatMessage({
              id: "map.layer.boundaries.legend.demography.upsell.title",
              defaultMessage: "Upgrade to Advanced Boundaries",
              description: "Title of the upsell legend for Advanced boundaries",
            })}
      </div>
      <div className={styles.buttons}>
        <Button
          href="https://map-my-customers.navattic.com/app-view"
          target="_blank"
          type={singleButton ? "primary" : "default"}
        >
          {intl.formatMessage({
            id: "map.layer.boundaries.legend.upsell.tourButton",
            defaultMessage: "Take a Tour",
            description: "Tour button in the upsell legend for boundaries",
          })}
        </Button>
        {!singleButton && (
          <Button
            href="https://mapmycustomers.com/territory-management-cs-release/"
            target="_blank"
            type="primary"
          >
            {intl.formatMessage({
              id: "map.layer.boundaries.legend.upsell.demoButton",
              defaultMessage: "Request Demo",
              description: "Demo button in the upsell legend for boundaries",
            })}
          </Button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  orgSize: getOrganization(state)?.teamSize ?? 0,
});

export default connect(mapStateToProps)(Upsell);
